export default __webpack_public_path__ + "static/swagger-afd1bfb8320b5e8ca2cefb7c4960463d.png";